<template>
	<div>
		<!-- 导航栏 -->
		<headerList></headerList>
		
		<!-- 分类名 - 总计 -->
		<div class="flex bg-ff special_img">
			<img :src="'http://tpahw.com/pub/api/files/' + picPath" alt="" />
		</div>
		
		<div class="special_box">
			
			<!-- 描述 -->
			<div class="relative miaos-box">
				<img class="absolute res_left" src="../assets/images/res_left.png" alt="" />
				<img class="absolute res_right" src="../assets/images/res_right.png" alt="" />
				<div v-html="descrp"></div>
			</div>
			
			<div class="section">
				<div class="img-wrapper" v-for="item,index in res_list" :key="index" @click="enterDetail(item.docId,item.doclibId)">
					<img class="img" lazy-load :src="item.middlePath" />
					<div class="info">
						<div class="size plr-20 onelist">{{item.resName}}</div>
					</div>
				</div>
			</div>
		</div>
		
	<!-- 	<div class="bg-f7 flex-c ptb-30" v-if="img_list.length">
			<Page class-name="page-class" :total="total" :page-size="40" @on-change="changePage" />
		</div> -->
		
		<footer-view></footer-view>
	</div>
</template>

<script>
	import headerList from './speciaHheader_nav.vue'
	import footerView from './footer.vue'
	export default {
		data () {
			return {
				topicId: 0,
				res_list: [],
				picPath:'',
				descrp: '',
				typeName: '',
			}
		},
		
		components: {
			headerList,
			footerView
		},
		
		created() {
			if (this.$route.name == 'xbcm' || this.$route.query.type == 'xbcm') {
				this.typeName = 'xbcm'
			}
			let _this = this
			_this.topicId = _this.$route.query.topicId
			// _this.picPath = _this.$route.query.picPath
		},
		
		mounted () {
			this.specialDetail()
			this.specialD()
		},
		
		methods: {
			async specialDetail () {
				let _this = this
				_this.$Spin.show()
				const res = await _this.get_res('/topic/res/page', {sld:'AHSCXB',topicId: _this.topicId, size: 100})
				_this.res_list = res.content
				_this.$Spin.hide()
			},
			
			async specialD () {
				let _this = this
				const res = await _this.get_res('/topic',{topicId: _this.topicId})
				_this.picPath = res.picPath
				_this.descrp = res.descrp
				document.title=res.name
			},
			
			// 跳转
			enterDetail (id,tid) {
				if (tid == 25 || tid == 837) {
							this.$router.push({path:'/specialimg_detail',query: {id,tid,type: this.typeName}})
						} else if (tid == 28) {
							this.$router.push({path:'/audio_detail',query: {id,tid}})
						} else {
							this.$router.push({path:'/video_detail',query: {id,tid}})
						}
			},
		},
	}
</script>

<style lang="less" scoped>
.ivu-page-item-active {
	border-color: #2d8cf0;
	color: #fff;
	background-color: #2d8cf0;
}
.ivu-page-item-active a {
	color: #fff!important;
}
.special_box {
	padding: 25px 0;
	background-color: #fff;
}
.special_img {
	padding-top: 85px;
}
.special_img img {
	width: 100%;
	height: 600px;
}
.section {
	  display: flex;
		width: 1230px;
	  flex-wrap: wrap;
	  padding: 25px 30px;
		background-color: #f7f7f7;
		margin: 0 auto;
	  .img-wrapper {
			cursor: pointer;
	    flex-grow: 1;
	    margin: 5px;
	    position: relative;
	    overflow: hidden;
	    height: 210px;
	    .img {
	      height: 100%;
	      background-size: cover;
	      background-position: center;
				object-fit: cover;
	    }
			img {
			  opacity: 1;
			  min-width: 100%;
			  height: 210px;
			}
	    .info {
	      position: absolute;
	      bottom: 0px;
	      color: #ffffff;
	      left: 0;
	      right: 0;
	      background-color: rgba(0, 0, 0, 0.3);
	      line-height: 44px;
	      height: 0px;
	    }
	   
	  }
		.img-wrapper:hover .info {
			height: 40px;
			transition: all 0.2s;
	  }
}

.section&::after {
		content: "";
		flex-grow: 99999;
	}
	
	// 空状态列表
	.list_empty {
		width: 100%;
		.iconwushuju {
			font-size: 200px;
		}
	}
	
// 新加描述
.miaos-box {
	padding: 34px 68px 40px 75px;
	width: 1230px;
	margin: 20px auto 50px;
	.res_left {
		width: 68px;
		height: 34px;
		top: 0;
		left: 0;
	}
	.res_right {
		width: 75px;
		height: 40px;
		right: 0;
		bottom: 0;
	}
	p {
		font-size: 16px;
		color: #333;
		
	}
}
</style>
